import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { Button, Checkbox, Input, Select, Textarea } from 'components/common';
import { normalizeUploadedImageUrl } from 'apis/uploadImage';

const typeName = (type) => type?.name || type?.label || type?.translations?.[0]?.name || type?.code || `Loại ${type?.id}`;

const ProjectInformationItemsEditor = ({
    items,
    languages,
    activeTab,
    types,
    onItemChange,
    onTranslationChange,
    onAdd,
    onRemove,
}) => {
    const language = languages[activeTab];

    return (
        <section className="project-information-inline leader-information-form">
            <div className="project-information-inline__heading">
                <div>
                    <p className="form-section-title">Thông tin dự án</p>
                    <span>Thêm và chỉnh sửa trực tiếp các thông tin hiển thị trên dự án.</span>
                </div>
                <Button type="button" variant="secondary" className="information-item-add" onClick={onAdd}><FiPlus size={16} /> Thêm thông tin</Button>
            </div>

            {items.map((item, index) => {
                const translation = item.translation.find((entry) => Number(entry.languageId) === Number(language?.id)) || {};
                const selectedType = types.find((type) => Number(type.id) === Number(item.projectInformationTypeId));
                const icon = normalizeUploadedImageUrl(selectedType?.iconURL || selectedType?.iconUrl || '');

                return (
                    <div className="admin-nested-block information-item-card" key={item.id || index}>
                        <div className="information-item-card__header">
                            <div>
                                <span className="information-item-card__number">{String(index + 1).padStart(2, '0')}</span>
                                <strong>{selectedType ? typeName(selectedType) : `Thông tin ${index + 1}`}</strong>
                            </div>
                            <button type="button" className="information-item-card__remove" onClick={() => onRemove(index)} title="Xóa thông tin"><FiTrash2 size={16} /><span>Xóa</span></button>
                        </div>

                        <div className="information-item-card__settings">
                            <Select label="Loại thông tin *" value={item.projectInformationTypeId} onChange={(event) => onItemChange(index, 'projectInformationTypeId', event.target.value)} options={types.map((type) => ({ value: type.id, label: typeName(type) }))} placeholder="Chọn loại thông tin" required />
                            <Input label="Thứ tự" type="number" value={item.sortOrder} onChange={(event) => onItemChange(index, 'sortOrder', event.target.value)} />
                            <div className="information-item-card__status"><span>Trạng thái</span><Checkbox label="Hoạt động" checked={item.isActive} onChange={(event) => onItemChange(index, 'isActive', event.target.checked)} /></div>
                        </div>

                        {selectedType && (
                            <div className="project-information-inline__type">
                                {icon && <img src={icon} alt="" />}
                                <span>{selectedType.code}</span>
                            </div>
                        )}

                        {language && (
                            <Textarea label={`Giá trị (${language.name}) *`} value={translation.value || ''} onChange={(event) => onTranslationChange(index, language.id, event.target.value)} rows={3} required />
                        )}
                    </div>
                );
            })}
        </section>
    );
};

export default ProjectInformationItemsEditor;
